export default __webpack_public_path__ + "static/app-store-50f08cb6dfcc658bba697ef6f17b0e88.png";